export default __webpack_public_path__ + "static/media/platform-background.6e4efc66.svg";